import { ClassicPreset as Classic, GetSchemes, NodeEditor, Root } from 'rete';

import { LogNode } from "../nodes/examples/LogNode";
import { StartNode } from "../nodes/startNode";
import { TextNode } from "../nodes/textNode";
import { ControlFlowEngine, DataflowEngine } from 'rete-engine';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import HelperLoading from '../../../../../../../common/infrastructure/funciones/HelperLoading';
import { IapWorkFlowActivityVariable } from '../../../../domain/service/iapWorkFlowActivityVariable';
import CatalogCommandConst from '../../../../../catalog/domain/const/CatalogCommandConst';
import { IapWorkFlowActivity } from '../../../../domain/service/iapWorkFlowActivity';
import { Container } from 'inversify';
import { IServiceWorkFlowActivityConnection } from '../../../../application/interface/IServiceWorkFlowActivityConnection';
import { TYPES } from '../../../../../../../common/domain/types';
import { IapWorkFlowActivityConnection } from '../../../../domain/service/iapWorkFlowActivityConnection';
import { IapWorkFlow } from '@ilinium/shared/src/entidades/builder/workflow/domain/service/iapWorkFlow';
import { IServiceWorkFlowActivity } from '../../../../application/interface/IServiceWorkFlowActivity';
import HelperWorkFlow from '../../../functions/helperWorkFlow';
import { DataSourceNode } from '../nodes/dataSourceNode';
import { Area2D, AreaPlugin } from 'rete-area-plugin';
import { VueArea2D } from 'rete-vue-plugin';
import { ContextMenuExtra } from 'rete-context-menu-plugin';
import { MinimapExtra } from 'rete-minimap-plugin';
import { RerouteExtra } from 'rete-connection-reroute-plugin';
import { IapComponent } from '../../../../../component/domain/iapComponent';
import { RedirectNode } from '../nodes/redirectNode';
import { DelayNode } from '../nodes/delayNode';
import { Router } from 'vue-router';
import HelperUtils from '../../../../../../../common/infrastructure/funciones/HelperUtils';
import { StoreProcedureNode } from '../nodes/storeProcedureNode';
import { MessageNode } from '../nodes/messageNode';
import HelperCommon from '../../../../../../../common/infrastructure/funciones/HelperCommon';
import { DisplayComponentNode } from '../nodes/displayComponentNode';
import { ChangeComponentNode } from '../nodes/changeComponentNode';
import StoreProcedureNodeConst from '../constants/StoreProcedureNodeConst';
import DisplayComponentNodeConst from '../constants/DisplayComponentNodeConst';
import MessageNodeConst from '../constants/MessageNodeConst';
import ConditionNodeConst from '../constants/ConditionNodeConst';
import { ConditionNode } from '../nodes/conditionNode';
import TextNodeConst from '../constants/TextNodeConst';
import ChangeComponentNodeConst from '../constants/ChangeComponentNodeConst';




export class Connection<
  A extends NodeProps,
  B extends NodeProps
> extends Classic.Connection<A, B> {
  isLoop?: boolean;
}

export type AreaExtra =
  | Area2D<Schemes>
  | VueArea2D<Schemes>
  | ContextMenuExtra
  | MinimapExtra
  | RerouteExtra;

export type NodeProps = StartNode | LogNode | TextNode | DataSourceNode | RedirectNode | DelayNode | StoreProcedureNode | DisplayComponentNode | ChangeComponentNode | MessageNode | ConditionNode;
export type ConnProps = Connection<StartNode, LogNode> 
| Connection<TextNode, LogNode> 
| Connection<StartNode, DataSourceNode>
| Connection<DataSourceNode, DataSourceNode>
| Connection<StartNode, DelayNode>
| Connection<DelayNode, DelayNode>
| Connection<StartNode, RedirectNode>
| Connection<RedirectNode, RedirectNode>

| Connection<StartNode, StoreProcedureNode>
| Connection<StoreProcedureNode, StoreProcedureNode>

| Connection<StartNode, DisplayComponentNode>
| Connection<DisplayComponentNode, DisplayComponentNode>

| Connection<StartNode, ChangeComponentNode>
| Connection<ChangeComponentNode, ChangeComponentNode>

| Connection<StartNode, MessageNode>
| Connection<MessageNode, MessageNode>

| Connection<StartNode, ConditionNode>
| Connection<ConditionNode, ConditionNode>


;


export type Schemes = GetSchemes<NodeProps, ConnProps>;



export default function HelperRete(
  router:Router,
  container: HTMLElement | undefined, wf: IapWorkFlow, catalogTypes: IapCatalogType[], srvContainer: Container | undefined, store: any
  , applicationId:number, applicationVersion:number,rootParentId:number, componentId: number, componentData: IapComponent[], updateNode: any = undefined,
  getNodeInternalData: any = undefined,showExpressionControl: any = undefined
) {

  const { addWorkFlowActivity, updateWorkFlowActivity,updateWorkFlowActivityVariable,updateWorkFlowActivityControl, addWorkFlowActivityConnection, deleteWorkFlowActivity, removeWorkFlowActivityConnection } = HelperWorkFlow(wf, srvContainer, store);

  let area: any = null;
  if (container) {
    area = new AreaPlugin<Schemes, AreaExtra>(container);
  }



  const socket = new Classic.Socket('socket');
  const currentComponent = componentData.find(x => x.id == componentId)
  const dataSources = componentData.filter(x => x.iapComponentDataSources).flatMap(x => x.iapComponentDataSources)




  const dataflow = new DataflowEngine<Schemes>(({ inputs, outputs }) => {
    return {
      inputs: () => Object.keys(inputs).filter((name) => name !== "ejecutar"),
      outputs: () => Object.keys(outputs).filter((name) => name !== "ejecutar")
    };
  });

  const engine = new ControlFlowEngine<Schemes>(() => {
    return {
      inputs: () => ["ejecutar"],
      outputs: () => ["ejecutar","ok","cancel","true","false"]
    };
  });




  const getCommandsList = (tipo: string, catalogTypes: IapCatalogType[]) => {

    if (catalogTypes && catalogTypes.length > 0) {
      const cats = catalogTypes.flatMap(x => x.iapCatalogs)
      if (cats) {
        return cats.filter(x => x.typeId == tipo && x.active).map(x => x.description, () => new StartNode(socket))
      }
    }

    return [];

  }

  const getTypeFromNode = (data: any): string => {
    if (data instanceof StartNode) {
      return CatalogCommandConst.CMD_START;
    }

  
    if (data instanceof LogNode) {
      return CatalogCommandConst.CMD_MSG;
    }


    if (data instanceof DataSourceNode) {
      return CatalogCommandConst.CMD_SELECTDATASOURCE;
    }


    if (data instanceof DelayNode) {
      return CatalogCommandConst.DELAY;
    }

    if (data instanceof RedirectNode) {
      return CatalogCommandConst.CMD_REDIRECT;
    }
    if (data instanceof StoreProcedureNode){
      return CatalogCommandConst.EXEC_PROC;
    }

    if (data instanceof DisplayComponentNode){
      return CatalogCommandConst.EXEC_SHOWFORM;
    }

    if (data instanceof ChangeComponentNode){
      return CatalogCommandConst.CMD_CHANGECOMP;
    }

    
    if (data instanceof MessageNode){
      return CatalogCommandConst.CMD_MSG;
    }

    if (data instanceof ConditionNode){
      return CatalogCommandConst.CMD_CONDICION;
    }


    return CatalogCommandConst.CMD_TEXT;

  }


  const addWorkFlowActivityFromContext = (context: any) => {    
    const data = {
      type: getTypeFromNode(context.data),
      left: 100,
      top: 100,
      color: '#FFFFFF',
      name: context.data.id,
      label: context.data.label ?? '',
      isInvalid: false,
      canDelete: true,
      inputNames: Object.keys(context.data.inputs).map(k =>
      ({
        key: k,
        value: context.data.controls[k]?.value?.toString() ?? ''
      })
      )
      ,
    
      outputNames: Object.keys(context.data.outputs).map(k =>
      ({
        key: k,
        value: context.data.controls[k]?.value?.toString() ?? ''
      })
      ),
      controls: Object.keys(context.data.controls).map(k =>
        ({
          key: k,
          value: context.data.controls[k]?.value?.toString() ?? ''
        })
        ).concat(
          Object.keys(context.data.controls?.value ?? []).filter(x=> x && x?.startsWith('variable')).map(k =>
            ({
              key: k,
              value: JSON.stringify(HelperCommon.isNullOrWhitespace(context.data.controls.value[k]) ? '' :context.data.controls.value[k])
            }) 
        ) ?? [] 
        ),
    }


    addWorkFlowActivity(data)
  }

  const updateWorkFlowActivityVariableFromContext = (id:string, variableName:string, variableValue:any, isInput:boolean) => {
    const sourceact = wf?.iapWorkFlowActivities.find(x => x.name == id);

    if (sourceact) {

      const variable = sourceact.iapWorkFlowActivityVariables.find(x=> x.name == variableName && x.isInput == isInput)
      if (variable && variable.defaultValue !== variableValue?.toString()){
        variable.defaultValue = variableValue?.toString() ?? ''
        variable.fum=new Date();
        variable.uum =  store.getters.getCurrentUser.id,
        updateWorkFlowActivityVariable([variable])
      }
    }
  }

  
  const updateWorkFlowActivityControlFromContext = (id:string, variableName:string, variableValue:any) => {
    const sourceact = wf?.iapWorkFlowActivities.find(x => x.name == id);
    
    if (sourceact) {
      const variableControl = sourceact.iapWorkFlowActivityControls.find(x=> x.name == variableName )
      if (variableControl && variableControl.value !== variableValue?.toString()){
        variableControl.value = variableValue?.toString() ?? ''
        updateWorkFlowActivityControl(variableControl)
      }
    }
  }

  const getWorkFlowActivityControlFromContext = (id:string, variableName:string) => {
    const sourceact = wf?.iapWorkFlowActivities.find(x => x.name == id);
    
    if (sourceact) {
      const variableControl = sourceact.iapWorkFlowActivityControls.find(x=> x.name == variableName )
      return variableControl;
    }
  }

  const getWorkFlowActivityVariableFromContext = (id:string, variableName:string, isInput:boolean) => {
    const sourceact = wf?.iapWorkFlowActivities.find(x => x.name == id);

    if (sourceact) {

      const variable = sourceact.iapWorkFlowActivityVariables.find(x=> x.name == variableName && x.isInput == isInput)
      return variable;
    }
  }


  const addWorkFlowActivityConnectionFromContext = (context: any) => {
    const sourceact = wf?.iapWorkFlowActivities.find(x => x.name == context.data.source);
    const targetact = wf?.iapWorkFlowActivities.find(x => x.name == context.data.target);
    if (sourceact && targetact) {
      const auxcn: IapWorkFlowActivityConnection = ({
        id: 0,
        externalId: context.data.id,
        workFlowActivityVariableIdInput: sourceact.iapWorkFlowActivityVariables.find(v => v.name == context.data.sourceOutput)?.id ?? -1,
        workFlowActivityVariableIdOutput: targetact.iapWorkFlowActivityVariables.find(v => v.name == context.data.targetInput)?.id ?? -1,
        fcr: new Date(),
        ucr: store.getters.getCurrentUser.id,
        uum: store.getters.getCurrentUser.id,
        fum: new Date(),
        group:HelperUtils.newGuid(),
      })

      addWorkFlowActivityConnection(sourceact.id, targetact.id, [auxcn])
    }
  }


  const removeWorkFlowActivityConnectionFromContext = (iapconn: IapWorkFlowActivityConnection, context: any) => {
    const dsourceact = wf?.iapWorkFlowActivities.find(x => x.name == context.data.source);
    const dtargetact = wf?.iapWorkFlowActivities.find(x => x.name == context.data.target);
    if (iapconn && dsourceact && dtargetact) {
      removeWorkFlowActivityConnection(dsourceact.id, dtargetact.id, iapconn)
    }
  }

  function addDataToEditor(editor: NodeEditor<Schemes>, item: IapWorkFlowActivity, dataFlow: DataflowEngine<Schemes>) {
    let newnode: Classic.Node = {} as any;
    switch (item.typeWorkFlowId) {
      case CatalogCommandConst.CMD_START:
        newnode = new StartNode(socket);
        newnode.id = item.name;
        //editor.addNode(newnode as any)
        break;


      case CatalogCommandConst.CMD_MSG:
          const selectedMsg = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == MessageNodeConst.VAR_MSG_IN)?.value ?? '');
          const selectedPMsgType =parseInt(JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == MessageNodeConst.VAR_MSGTYPE_IN)?.value ?? '1')); //parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');          
          const selectedModalType =JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == MessageNodeConst.VAR_MSGMODAL_IN)?.value ?? 'false'); //parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');          
          newnode = new MessageNode(area, socket,rootParentId,componentId,applicationId,applicationVersion, selectedMsg,selectedPMsgType,selectedModalType, updateNode,getNodeInternalData,showExpressionControl,router,srvContainer,store,item, dataflow,componentData);
          newnode.id = item.name;

        break;

        case CatalogCommandConst.CMD_TEXT:
          const selectedText = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == TextNodeConst.VAR_TEXT_IN)?.value ?? '');
          newnode = new TextNode(area, socket,rootParentId,componentId,applicationId,applicationVersion, selectedText,updateNode,getNodeInternalData,showExpressionControl,router,srvContainer,store,item,componentData);
          newnode.id = item.name;

        break;

      case CatalogCommandConst.CMD_SELECTDATASOURCE:
        const selectedValue = parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');
        newnode = new DataSourceNode(area, socket, componentId, selectedValue, dataSources, updateNode);
        newnode.id = item.name;

        break;

      case CatalogCommandConst.CMD_REDIRECT:

        const selectedValueRed = parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');
        newnode = new RedirectNode(area, socket, selectedValueRed, updateNode,router,store,componentData);
        newnode.id = item.name;

        break;

        case CatalogCommandConst.DELAY:
          const selectedValueDelay = parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');
          newnode = new DelayNode(socket, selectedValueDelay, updateNode);
          newnode.id = item.name;
  
          break;

          case CatalogCommandConst.EXEC_PROC:
          const selectedConn = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == StoreProcedureNodeConst.VAR_CONN_IN)?.value ?? '""');
          const selectedProc = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == StoreProcedureNodeConst.VAR_PROC_IN)?.value ?? '""'); //parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');
          const selectedParamInputs =JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == StoreProcedureNodeConst.VAR_PARAM_IN)?.value ?? '[]') as any;
          newnode = new StoreProcedureNode(area, socket,rootParentId,componentId,applicationId,applicationVersion, selectedConn,selectedProc,selectedParamInputs, updateNode,getNodeInternalData,showExpressionControl,router,srvContainer,store,item,componentData);
          newnode.id = item.name;

          break;

          case CatalogCommandConst.EXEC_SHOWFORM:
            const selectedComp = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == DisplayComponentNodeConst.VAR_COMP_IN)?.value ?? '""');
            const selectedCompModal = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == DisplayComponentNodeConst.VAR_COMPMODAL_IN)?.value ?? '""'); //parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');
            const selectedCompParamInputs =JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == DisplayComponentNodeConst.VAR_PARAM_IN)?.value ?? '[]') as any;
            const selectedCompHeader = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == DisplayComponentNodeConst.VAR_HEADER_IN)?.value ?? '""'); //parseInt(item.iapWorkFlowActivityControls.find(x => x.name == 'value')?.value ?? '-1');
            newnode = new DisplayComponentNode(area, socket,rootParentId,componentId,applicationId,applicationVersion, selectedComp,selectedCompHeader,selectedCompModal,selectedCompParamInputs, updateNode,getNodeInternalData,showExpressionControl,router,srvContainer,store,item,componentData);
            newnode.id = item.name;
  
          

            break;

            case CatalogCommandConst.CMD_CHANGECOMP:
              const selectedCompId = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == ChangeComponentNodeConst.VAR_COMP_IN)?.value ?? '""');
              const selectedCompAttrsInputs =JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == ChangeComponentNodeConst.VAR_ATTR_IN)?.value ?? '[]') as any;              
              const selectedCompEventsInputs =JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == ChangeComponentNodeConst.VAR_EVENT_IN)?.value ?? '[]') as any;              
              newnode = new ChangeComponentNode(area, socket,rootParentId,componentId,applicationId,applicationVersion, selectedCompId,selectedCompAttrsInputs,selectedCompEventsInputs, updateNode,getNodeInternalData,showExpressionControl,router,srvContainer,store,item,dataflow,componentData);
              newnode.id = item.name;
    
            
  
              break;
  
            case CatalogCommandConst.CMD_CONDICION:
              const selectedCondition = JSON.parse(item.iapWorkFlowActivityControls.find(x => x.name == ConditionNodeConst.VAR_COND_IN)?.value ?? '"');
              newnode = new ConditionNode(area, socket,rootParentId,componentId,applicationId,applicationVersion, selectedCondition,updateNode,getNodeInternalData,showExpressionControl,router,srvContainer,store,item,componentData);
              newnode.id = item.name;
    
            break;
            
          


    }

   



    return newnode;
  }

  return {
    wf,
    dataflow,
    engine,
    socket,
    deleteWorkFlowActivity,
    addWorkFlowActivityFromContext,
    addWorkFlowActivityConnectionFromContext,
    removeWorkFlowActivityConnectionFromContext,
    addDataToEditor,
    area,
    currentComponent,
    dataSources,
    updateNode,
    getNodeInternalData,
    showExpressionControl,
    updateWorkFlowActivityVariableFromContext,
    updateWorkFlowActivityControlFromContext,
    getWorkFlowActivityControlFromContext,
    getWorkFlowActivityVariableFromContext

  };
}





//////////////////////////////////////////////////////////////








